import React from "react";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
var RedeemEditFooter = function (_a) {
    var onClickCancel = _a.onClickCancel, onClickContinue = _a.onClickContinue, disabled = _a.disabled;
    return (React.createElement("div", { className: "footer-container" },
        React.createElement(EdButton, { btnTyp: "link", value: "Cancel", className: "DMSans_16_500", onClick: onClickCancel }),
        React.createElement(EdButton, { btnTyp: "tomato", value: "Save", className: "save-button rounded-pill DMSans_16_500", disabled: disabled, onClick: onClickContinue })));
};
export default RedeemEditFooter;
